import { A } from '@adornis/base/env-info.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { type BaseQLSelectionSet, selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Appointment } from '../entities/appointment.js';
import { Product } from '../entities/products.js';
import { UserStammdaten } from '../entities/stammdaten.js';
import { Suspension } from '../entities/suspension.js';
import { User } from '../entities/user.js';

@Entity()
export class LecturerDataview extends AdornisEntity {
  static override _class = 'LecturerDataview';

  static override resolveID(entity: LecturerDataview): string {
    if (!entity._id) return (entity._id = A.getGloballyUniqueID());
    return entity._id;
  }

  @validate(nonOptional())
  @Field(type => String)
  _id!: string;

  @validate(nonOptional())
  @Field(type => User)
  user!: User;

  @Field(type => UserStammdaten)
  userStammdaten!: UserStammdaten;

  @validate(nonOptional())
  @Field(type => [Product])
  products!: Product[];

  public static get neededGqlFields(): BaseQLSelectionSet<LecturerDataview> {
    return {
      _id: 1,
      _class: 1,
      user: {
        _id: 1,
        _class: 1,
        email: 1,
        username: 1,
        firstName: 1,
        lastName: 1,
        suspentions: selectionSet(() => Suspension, 2),
      },
      userStammdaten: selectionSet(() => UserStammdaten, 3),
      products: {
        _id: 1,
        _class: 1,
        name: 1,
        prices: { unitAmount: 1 },
        sortingWeight: 1,
        hasPrice: 1,
        category: { name: 1 },
        institutionID: 1,
        timeframeID: 1,
        timeframe: { _id: 1, name: 1 },
        productCopyID: 1,
        publishDate: 1,
        topic: 1,
        language: 1,
        presenceType: 1,
        isCanceled: 1,
        ...{ appointments: selectionSet(() => Appointment, 1), capacity: 1 },
      },
    } as const satisfies BaseQLSelectionSet<LecturerDataview>;
  }
}
